export default __webpack_public_path__ + "static/media/celular-suvinil.80ad1117.png";